import React from "react" // eslint-disable-line no-unused-vars
/** @jsx jsx */
import { jsx, Box, Flex } from "theme-ui"
import { RCAImage } from "../../common/RCAImage"

const ProgrammeSponsorItem = ({ sponsor }) => {
  return (
    <Flex columns={[1, 2]} gap={0} sx={{ mb: [3, 4] }}>
      <Box sx={{ width: ["100%, 50%"] }}>
        <Box sx={{ fontWeight: "bold" }}>
          <a href={sponsor?.sponsorUrl} target="_blank" rel="noreferrer">
            {sponsor.sponsorName}
          </a>
        </Box>
        <Box>{sponsor.description}</Box>
      </Box>
    </Flex>
  )
}

export default ProgrammeSponsorItem
